import { action, observable } from 'mobx';
import * as api from '../services/api';
import UserStore from './common/UserStore';
import moment from 'moment';

class OrdersKitchenStore {
    @observable deliveryOrders = [];
    @observable dineInOrders = [];
    @observable instaServiceProductions = [];
    @observable deliveryOrdersLoading = true;
    @observable dineInOrdersLoading = true;
    @observable currentWarmerStocks = [];
    deliveryOrdersLastModified = null;
    dineInOrdersLastModified = null;
    instaServiceLastModified = null;
    @observable inCartOrders = [];
    @observable inCartItems = [];

    @observable date = moment().format('DD-MM-YYYY');

    @action handleGetDeliveryOrders = (
        forceLatest = false,
        date = this.date,
        tokenParam = null,
        hubCode = null
    ) => {
        let ifModifiedSince = null;
        if (!forceLatest) {
            ifModifiedSince = this.deliveryOrdersLastModified;
        }
        api.getDeliveryOrders(date, ifModifiedSince, tokenParam, hubCode)
            .then((res) => {
                if (res.modified) {
                    const { lastModified, responseBody } = res;
                    this.deliveryOrdersLastModified = lastModified;
                    if (!responseBody.list) {
                        //there's no delivery order
                        this.deliveryOrders = [];
                    }
                    //this array will be used to filter out completed orders from prepared/Done orders list
                    if (responseBody.list && responseBody.list.length > 0) {
                        this.deliveryOrders =
                            responseBody.list.filter(
                                (order) => order.status === 'Pending'
                            ) || [];
                    }
                } else {
                    // no change since the last call
                }
            })
            .catch((err) => {
                console.log(err);
                UserStore.message = err.message;
            })
            .finally(() => {
                this.deliveryOrdersLoading = false;
            });
    };


    @action getInCartOrders = (tokenParam = null, hubCode = null) => {
        this.inCartOrders = [];
        api.getInCartOrders(tokenParam, hubCode)
            .then((inCartOrders) => {
                this.inCartOrders = inCartOrders
                .filter(order => Array.isArray(order.items) && order.items.length > 0)
                .map(order => ({
                    ...order,
                    items: order.items.flatMap(item => {
                        // Duplicate item based on quantity
                        return Array(item.quantity).fill().map(() => ({
                            ...item,
                            amount: 1,
                            pick_up_type: order.order_mode,
                            sale_platform: "PopMeals",
                        }));
                    }),
                }));

            this.inCartItems = this.inCartOrders.flatMap(order => order.items);
            })
            .catch((err) => {
                console.log(err);
                UserStore.message = err.message;
            })
    };

    @action handleGetDineInOrders = (forceLatest = false, date = this.date, tokenParam = null, hubCode = null) => {
        this.date = date;
        let ifModifiedSince = null;
        if (!forceLatest) {
            ifModifiedSince = this.dineInOrdersLastModified;
        }

        api.getDineInOrders(this.date, ifModifiedSince, tokenParam, hubCode)
            .then((res) => {
                if (res.modified) {
                    const { lastModified, responseBody } = res;
                    const { list: dineInOrders, message } = responseBody;
                    this.dineInOrdersLastModified = lastModified;
                    const newDineInOrders = dineInOrders
                        ? dineInOrders.filter(
                              (order) =>
                                  order.status === 'Pending' &&
                                  order.items &&
                                  order.items.length > 0
                          )
                        : [];

                    const sortedDineInOrders =
                        newDineInOrders &&
                        newDineInOrders.sort(
                            (a, b) => a.order_date - b.order_date
                        );

                    this.dineInOrders = sortedDineInOrders
                        ? [...sortedDineInOrders]
                        : [];
                }
            })
            .catch((err) => {
                UserStore.message = err.message;
            })
            .finally(() => {
                this.dineInOrdersLoading = false;
            });
    };

    @action handleGetInstaServiceProductions = (
        forceLatest = false,
        tokenParam = null,
        hubCode = null
    ) => {
        let ifModifiedSince = null;
        if (!forceLatest) {
            ifModifiedSince = this.instaserviceLastModified;
        }
        api.getInstaServiceProduction(ifModifiedSince, tokenParam, hubCode)
            .then((res) => {
                if (res.modified) {
                    const { lastModified, responseBody } = res;
                    this.instaserviceLastModified = lastModified;
                    this.instaServiceProductions = responseBody.list ? responseBody.list : [];
                    this.instaServiceLastModified = lastModified;
                    if (responseBody.current_stock) {
                        this.currentWarmerStocks = responseBody.current_stock;
                    }
                } else {
                    // no change since the last call
                }
            })
            .catch((err) => {
                console.log(err);
                UserStore.message = err.message;
            })
    };

    initOrderData = (data) => {
        const { bags, dine_in_orders, routes } = data;

        const deliveryBags = bags;

        this.deliveryOrders = deliveryBags;
        this.deliveryOrdersLoading = false;

        if (routes && routes.length) {
            routes.forEach((route) => {
                route.bags.forEach((bag) => {
                    const bagIndex = this.deliveryOrders.findIndex((order) => {return order.order_number == bag.order_number});
                    if (bagIndex >= 0) {
                        this.deliveryOrders.splice(bagIndex, 1);
                    }
                    if (bag.status != 'Delivered' && bag.status != 'Cancelled') {
                        this.deliveryOrders.push(bag);
                    }
                });
            })
        }
        
        const newDineInOrders = dine_in_orders
                ? dine_in_orders.filter(
                        (order) =>
                            order.status == 'Pending' &&
                            order.items &&
                            order.items.length > 0
                    )
                : [];

        const sortedDineInOrders =
            newDineInOrders &&
            newDineInOrders.sort(
                (a, b) => a.order_date - b.order_date
            );

        this.dineInOrders = sortedDineInOrders
            ? [...sortedDineInOrders]
            : [];
        this.dineInOrdersLoading = false;
    }

    populateChanges = (data) => {
        const { bags, dine_in_orders, routes } = data;
        if (!this.deliveryOrders) {
            this.deliveryOrders = [];
        }

        if (bags && bags.length) {
            const bag = bags[0];
            const index = this.deliveryOrders.findIndex((order) => {return order.order_number == bag.order_number});
            if (index >= 0) {
                this.deliveryOrders.splice(index, 1);
                if (bag.status != 'Delivered' && bag.status != 'Cancelled') {
                    this.deliveryOrders.push(bag);
                }
            } else {
                if (bag.status != 'Delivered' && bag.status != 'Cancelled') {
                    this.deliveryOrders.push(bag);
                }
            }
        }

        if (routes && routes.length) {
            const newRoute = routes[0];
            // Add new order from route to bags
            newRoute.bags.forEach((bag) => {
                const bagIndex = this.deliveryOrders.findIndex((order) => {return order.order_number == bag.order_number});
                if (bagIndex >= 0) {
                    this.deliveryOrders.splice(bagIndex, 1);
                }
                if (bag.status != 'Delivered' && bag.status != 'Cancelled') {
                    this.deliveryOrders.push(bag);
                }
            });
        }

        if (dine_in_orders && dine_in_orders.length) {
            const dineInOrder = dine_in_orders[0];
            const index = this.dineInOrders.findIndex((order) => {return order.order_number == dineInOrder.order_number});
            if (index >= 0) {
                this.dineInOrders.splice(index, 1);
            }
            if (dineInOrder.status == 'Pending') {
                this.dineInOrders.push(dineInOrder);
            }
            const sortedDineInOrders = this.dineInOrders.sort(
                (a, b) => a.order_date - b.order_date
            );
            this.dineInOrders = sortedDineInOrders
                ? [...sortedDineInOrders]
                : [];
        }
    }

    populateIncomingOrderChanges = (data) => {
        const { in_cart_orders } = data;

        if (in_cart_orders) {
            this.inCartOrders = in_cart_orders
                .filter(order => Array.isArray(order.items) && order.items.length > 0)
                .map(order => ({
                    ...order,
                    items: order.items.flatMap(item => {
                        // Duplicate item based on quantity
                        return Array(item.quantity).fill().map(() => ({
                            ...item,
                            amount: 1,
                            pick_up_type: order.order_mode,
                            sale_platform: "PopMeals",
                        }));
                    }),
                }));

            this.inCartItems = this.inCartOrders.flatMap(order => order.items);
        }
    };


    populateWarmerStockChanges = (data) => {
        const { warmer_response } = data;

        if (warmer_response) {
            this.instaServiceProductions = warmer_response.list ? warmer_response.list : [];
            if (warmer_response.current_stock) {
                this.currentWarmerStocks = warmer_response.current_stock;
            }
        }
    }

    @action updateOrderData = (dataStr) => {
        let data = JSON.parse(dataStr);
        if (data.type == 'init') {
            this.initOrderData(data);
        } else if (data.type == 'update') {
            this.populateChanges(data);
        }  else if (data.type == 'updateIncomingOrder') {
            this.populateIncomingOrderChanges(data);
        }  else if (data.type == 'updateWarmerStock') {
            this.populateWarmerStockChanges(data);
        }
    };
}

const store = new OrdersKitchenStore();
export default store;
